"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putOrganizationContractAcceptTerms = exports.getOrganizationsContracts = void 0;

const getOrganizationsContracts = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/contracts`;
  const params = {
    includeInactiveContracts: options.includeInactiveContracts === undefined ? true : options.includeInactiveContracts,
    includeLegacyCSFields: options.includeLegacyCSFields === undefined ? true : options.includeLegacyCSFields,
    includeTermsAcceptances: options.includeTermsAcceptances === undefined ? false : options.includeTermsAcceptances
  };
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getOrganizationsContracts = getOrganizationsContracts;

const putOrganizationContractAcceptTerms = (jilFetch, options) => {
  const {
    contractId,
    orgId,
    requestInit
  } = options;
  const path = `organizations/${orgId}/contracts/${contractId}:acceptTerms`;
  return jilFetch(path, null, Object.assign(Object.assign({}, requestInit), {
    method: 'PUT'
  }));
};

exports.putOrganizationContractAcceptTerms = putOrganizationContractAcceptTerms;